
















import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IRefDetail } from "./RefsList.vue";
import { IPersonEmail } from "@/models/person-email.entity";

@Component({
  components: {},
  filters: {}
})
export default class RefsPersonEmail extends mixins(Vue) implements IRefDetail<IPersonEmail> {
  @Prop()
  item!: IPersonEmail;

  @Prop()
  small!: boolean;

  @Prop()
  confirmable!: boolean;

  async goToDetail() {
    throw new Error("Method not implemented.");
  }

  copy() {
    this.item.copyToClipboard();
  }
}
